import { IStandardCareProposal } from '@pia/pia.shared';
import { Inject, Injectable, NgZone } from '@angular/core';
import { StandardCareProposalChannel } from 'src/app/business/standard-careproposal/contracts/standard-careproposal-channel';
import { IAppController } from 'src/app/common/contracts/controller/app-controller';
import { IDispatcher } from 'src/app/common/contracts/dispatch/dispatcher';
import { IPlatformSync, PlatformSyncToken } from 'src/app/common/contracts/sync/platform-sync';
import { AppController } from 'src/app/common/controller/app-controller';
import { Dispatcher } from 'src/app/common/dispatch/dispatcher';

import { StandardCareProposalModelName } from '../../models/model-names';
import { SyncProgressEvent } from '../../models/sync-progress-event';
import { EventService } from '../event.service';
import { SyncService } from './sync.service';

@Injectable()
export class StandardCareProposalSyncService extends SyncService<IStandardCareProposal> {
  constructor(
    @Inject(AppController) appController: IAppController,
    @Inject(Dispatcher) dispatcher: IDispatcher<IStandardCareProposal>,
    eventService: EventService<SyncProgressEvent>,
    ngZone: NgZone,
    @Inject(PlatformSyncToken) platformSync: IPlatformSync
  ) {
    super(StandardCareProposalModelName, appController, dispatcher, eventService, ngZone, platformSync);
  }
  public canSync(channel: string): boolean {
    return (
      channel === StandardCareProposalChannel.CREATE ||
      channel === StandardCareProposalChannel.EDIT ||
      channel === StandardCareProposalChannel.DELETE
    );
  }
}
